import {observer} from 'mobx-react';
import React from 'react';
import {PromiseMessage} from '../../../../lib/components';
import {X1LanguageStore} from '../X1LanguageStore';

@observer
export class AddAgeCategoryControls extends React.Component<{ store: X1LanguageStore }> {
  render() {
    const {store} = this.props;

    if (store.addAgeCategory === null)
      return null;

    const add = store.addAgeCategory;
    const isPending = add.save?.isPending === true;

    return (<>
      <div className="row justify-content-end">
        <div className="col-auto">
          <button type="button" className="btn btn-primary"
                  onClick={store.completeAdd}
                  disabled={isPending}>
            Save
          </button>
          <button type="button" className="btn btn-primary"
                  onClick={store.cancel}
                  disabled={isPending}>
            Cancel
          </button>
        </div>
      </div>

      <PromiseMessage label="Saving" state={add.save} align="right"/>
    </>);
  }
}
